import { render, staticRenderFns } from "./checklistTemplateOrdenation.vue?vue&type=template&id=52afbecd&scoped=true"
import script from "./checklistTemplateOrdenation.vue?vue&type=script&lang=js"
export * from "./checklistTemplateOrdenation.vue?vue&type=script&lang=js"
import style0 from "./checklistTemplateOrdenation.vue?vue&type=style&index=0&id=52afbecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52afbecd",
  null
  
)

export default component.exports